export enum SpecimenProcessingResultTab {
    Normal = 'normal',
    Culture = 'culture',
    Report = 'report',
}
